import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { setCookie } from "@miro-site/core";
import React, { useEffect, useState } from "react";
import { DEFAULT_LOCALE, LOCALE_COOKIE, LOCALE_LABELS, RTL_LANGUAGES } from "../constants";
import toBaseLocale from "../utils/toBaseLocale";
var defaultLocalizationData = {
    defaultLocale: DEFAULT_LOCALE,
    currentLocale: DEFAULT_LOCALE,
    isRTL: RTL_LANGUAGES.includes(DEFAULT_LOCALE),
    localeLabels: LOCALE_LABELS,
    onChangeLocale: function(locale) {
        return setCookie(LOCALE_COOKIE, locale, 0);
    },
    translations: []
};
export var LocaleContext = /*#__PURE__*/ React.createContext(defaultLocalizationData);
var LocalizationProvider = function(props) {
    var children = props.children, _data = props.data, data = _data === void 0 ? {} : _data, _detectLocale = props.detectLocale, detectLocale = _detectLocale === void 0 ? true : _detectLocale, _detectTranslations = props.detectTranslations, detectTranslations = _detectTranslations === void 0 ? true : _detectTranslations, _changeLocaleOnLoad = props.changeLocaleOnLoad, changeLocaleOnLoad = _changeLocaleOnLoad === void 0 ? true : _changeLocaleOnLoad, _useBaseLocale = props.useBaseLocale, useBaseLocale = _useBaseLocale === void 0 ? true : _useBaseLocale;
    var ref = useState({
        currentLocale: DEFAULT_LOCALE,
        translations: []
    }), detectedLocalizationData = ref[0], setDetectedLocalizationData = ref[1];
    var _NEXT_PUBLIC_BASE_PATH;
    var basePath = (_NEXT_PUBLIC_BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH) !== null && _NEXT_PUBLIC_BASE_PATH !== void 0 ? _NEXT_PUBLIC_BASE_PATH : "";
    var mergedData = _object_spread({}, defaultLocalizationData, detectedLocalizationData, data);
    var normalizeLocale = function(locale) {
        return useBaseLocale ? toBaseLocale(locale) : locale;
    };
    var defaultLocale = normalizeLocale(mergedData.defaultLocale);
    var currentLocale = normalizeLocale(mergedData.currentLocale);
    var translations = (mergedData.translations || []).map(function(t) {
        return _object_spread_props(_object_spread({}, t), {
            locale: normalizeLocale(t.locale)
        });
    });
    useEffect(function() {
        var detectedLocale = defaultLocale;
        var detectedTranslations = [];
        if (detectLocale) {
            var pathWithoutBasePath = document.location.pathname.replace(basePath, "");
            // Regex to allow mixed capitalization for language and region codes, like en-US, pt_BR, jp_JP
            var localePattern = /^\/([a-zA-Z]{2}(-[a-zA-Z]{2}|_[a-zA-Z]{2})?)/;
            var match = pathWithoutBasePath.match(localePattern);
            if (match && match[1]) {
                // Normalize the matched locale:
                // 1. Convert the first two characters (language code) to lowercase
                // 2. If a region code is present, keep the first character (either hyphen or underscore)
                // 3. Convert the remaining characters of the region code to uppercase
                var normalizedLocale = match[1].slice(0, 2).toLowerCase() + (match[1].length > 2 ? match[1].slice(2, 3) + match[1].slice(3).toUpperCase() : "");
                // Check if the normalized locale exists in LOCALE_LABELS
                if (LOCALE_LABELS[normalizedLocale]) {
                    detectedLocale = normalizedLocale;
                }
            }
        }
        if (detectTranslations) {
            detectedTranslations = Object.keys(window.mrTranslations || {}).reduce(function(acc, locale) {
                var a = document.createElement("a");
                a.href = window.mrTranslations[locale];
                acc.push({
                    locale: locale,
                    url: a.pathname || "/"
                });
                return acc;
            }, []);
        }
        if (detectLocale || detectTranslations) {
            setDetectedLocalizationData({
                currentLocale: detectedLocale,
                translations: detectedTranslations
            });
        }
    }, [
        detectLocale,
        detectTranslations
    ]);
    useEffect(function() {
        if (changeLocaleOnLoad && currentLocale !== defaultLocale) {
            mergedData.onChangeLocale(currentLocale);
        }
    }, [
        changeLocaleOnLoad
    ]);
    return /*#__PURE__*/ _jsx(LocaleContext.Provider, {
        value: _object_spread_props(_object_spread({}, mergedData), {
            defaultLocale: defaultLocale,
            currentLocale: currentLocale,
            isRTL: RTL_LANGUAGES.includes(currentLocale),
            translations: translations
        }),
        children: children
    });
};
export default LocalizationProvider;
